import {noop} from '@benchling/js-utils';

import {makeReactContext} from 'lib/makeReactContext';
import {ProcedureMaterialOutputSetting} from 'procedures/ProcedureDomainTypes';

import {FilteredProcedureMethodSection} from './ProcedureMethodSectionFilterDropdown';

export interface ProcedureEditorContextValue {
  handlesInUse: Array<string>;
  methodNamesInUse: Record<string, string>; // {cid: name}
  invalidMaterialHandles: Array<string>;
  setInvalidMaterialHandles: (handleIds: Array<string>) => void;
  editingNameMethodCid: string | null;
  setEditingNameMethodCid: (methodCid: string | null) => void;
  methodCidBeingDragged: string | null;
  selectedMethodSectionFilter: Array<FilteredProcedureMethodSection>;
  isProcedureReadOnly: boolean;
  numberOfMethods: number;
  materialOutputSettingBeingConnected: ProcedureMaterialOutputSetting | null;
}

export const ProcedureEditorContext = makeReactContext<ProcedureEditorContextValue>(
  () => ({
    handlesInUse: [],
    methodNamesInUse: {},
    invalidMaterialHandles: [],
    setInvalidMaterialHandles: noop,
    editingNameMethodCid: null,
    setEditingNameMethodCid: noop,
    methodCidBeingDragged: null,
    selectedMethodSectionFilter: [],
    isProcedureReadOnly: false,
    numberOfMethods: 0,
    materialOutputSettingBeingConnected: null,
  }),
  'ProcedureEditorContext'
);
